import { render, staticRenderFns } from "./EnrollWithId.vue?vue&type=template&id=56afca26&scoped=true&"
import script from "./EnrollWithId.vue?vue&type=script&lang=js&"
export * from "./EnrollWithId.vue?vue&type=script&lang=js&"
import style0 from "./EnrollWithId.vue?vue&type=style&index=0&id=56afca26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afca26",
  null
  
)

export default component.exports